import React, { useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.css";
import { QueryClientProvider } from "react-query";
import { QueryClient } from "react-query/core";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { reducer as formReducer } from "redux-form";
import thunk from "redux-thunk";
import AppReducer from "./app/reducers/AppReducer";
import AuthenticationReducer from "./app/reducers/AuthenticationReducer";
import { AppAuthentication } from "./app/ui/AppAuthentication";
import PopupReducer from "./shared/popups/reducers/PopupReducer";
import { LocalizedApp } from "src/app/components/LocalizedApp";

// Create Redux Store
const store = createStore(
  combineReducers({
    app: AppReducer,
    authentication: AuthenticationReducer,
    form: formReducer,
    popups: PopupReducer,
  }),
  compose(applyMiddleware(thunk)),
);

const App = () => {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: Infinity,
          },
        },
      }),
    [],
  );
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <LocalizedApp>
          <AppAuthentication />
        </LocalizedApp>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
